import type { ReactNode } from 'react';
import type { UpsaleProductsMappingType } from 'reactApp/sections/QuotaLanding/MultiTariffsList/hooks/useUpsaleProductsMapping';
import type { Product } from 'reactApp/types/Billing';
import type { TariffCardCustomProps } from 'reactApp/ui/TariffCardNew/TariffCard.types';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import type { ITariffsByTab } from 'reactApp/ui/TariffSectionNew/TariffsSection.types';

export interface IMobilePayProps {
    isIOSPromo?: boolean;
    isAndroidPromo?: boolean;
    isMobilePayAvailable: boolean;
    isMobilePayFromGetParam: boolean;
    enabledMidasPayment?: boolean;
}

// tempexp_16481-next-lines
export type TBuyClick = (props: {
    product: Product;
    paySource?: string;
    onClick?: () => void;
    space: number;
    skipClickAnalytics?: boolean;
}) => void;

export enum TariffBorder {
    /* tempexp_18084-start */
    tariffPersonalGreen = 'tariffPersonalGreen',
    tariffPersonalBlue = 'tariffPersonalBlue',
    tariffPersonalPink = 'tariffPersonalPink',
    /* tempexp_18084-end */
}

export type Props = IMobilePayProps & {
    // tempexp_18086-start
    isReferral?: boolean;
    activeTariffTab?: ETabsName;
    activeTab?: ETabsName;
    tariff: ITariffsByTab;
    shadowTariff?: ITariffsByTab;
    isVisible?: boolean;
    setCarouselLoaded?: (state: boolean) => void;
    // tempexp_18090-next-line
    onTariffClick?: () => void;
    isMultiTariff?: boolean;
    upsaleProductsMap?: UpsaleProductsMappingType;
    isHideButtonInMonthTariff?: boolean;
    mayPromo2025Enabled?: boolean;
    familyByOption?: boolean;
    setFamilyByOptions?: () => void;
    aiTariffByOption?: boolean;
    setAiTariffByOptions?: () => void;
    isFirstCard?: boolean;
    customHeader?(args: TariffCardCustomProps): ReactNode;
    customContent?(args: TariffCardCustomProps): ReactNode;
    blackFriday2025Enabled?: boolean;
    marchPromo2026Enabled?: boolean;
};
